import { useTranslation } from 'react-i18next';

import { PageMeta } from '@/components/layout/PageMeta';
import { BareLayout } from '@/layouts/BareLayout';

export function NotFoundPage() {
  const { t } = useTranslation('cashier');

  return (
    <BareLayout>
      <PageMeta title={t('notFound.title')} />
      <h1 className="text-text text-xl font-semibold tracking-tight" tabIndex={-1}>
        {t('notFound.title')}
      </h1>
      <p className="text-text-muted mt-3 text-sm leading-relaxed">{t('notFound.body')}</p>
    </BareLayout>
  );
}
